module.exports = global["surveylab_survey_alertValidationScroll"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./alert-validation-scroll.ts");